












































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ISideBar, IUser } from '@/types/types';

const auth = namespace('auth');
@Component
export default class SideBar extends Vue {
  @Prop({ type: Boolean, default: true }) drawer!: boolean;
  @Prop({ type: String, default: 'home' }) navigationKey!: string;
  @Prop({ type: Array, default: () => [], required: true }) sideBarItems!: Array<ISideBar | { label: string }>;
  @auth.Getter('getUserDetails') user!: IUser;
  closer: boolean = this.drawer;
  menu: boolean = false;
  isCollapsed: boolean = false;
  private collapseQuery: MediaQueryList | null = null;

  private onCollapseChange = (): void => {
    this.isCollapsed = !!this.collapseQuery && this.collapseQuery.matches;
  };

  /**
   * Vue Router's active class is an inclusive match, so a link like /payments
   * stays highlighted on /payments/merchants. Any sidebar link whose path is a
   * prefix of another sidebar link therefore has to match exactly. Computed
   * from the routes so adding a nested page later needs no extra flag.
   */
  get parentLinkNames(): string[] {
    const paths = this.sideBarItems
      .filter((item): item is ISideBar => 'link' in item && !!item.link)
      .map(item => {
        try {
          return { name: item.link, path: this.$router.resolve({ name: item.link }).route.path };
        } catch (e) {
          return null;
        }
      })
      .filter(Boolean) as Array<{ name: string; path: string }>;

    return paths
      .filter(
        ({ path }) =>
          // "/" prefixes every route, so unresolved (locked) links would other-
          // wise render permanently active.
          path === '/' || paths.some(other => other.path !== path && other.path.startsWith(`${path}/`)),
      )
      .map(({ name }) => name);
  }

  isParentOfAnotherLink(name: string): boolean {
    return this.parentLinkNames.includes(name);
  }

  get initials(): string {
    const name = (this.user && this.user.name) || '';
    const parts = name
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return 'KA';
    return parts
      .slice(0, 2)
      .map(part => part[0].toUpperCase())
      .join('');
  }

  logOut() {
    this.$store.dispatch('auth/logOut');
  }

  goBack() {
    this.$store.dispatch('navigation/setAppLinks', 'home');
    this.$router.replace({
      name: 'dashboard',
    });
  }

  mounted(): void {
    // Same breakpoint range that collapses .menubar to the icon rail in main.scss
    this.collapseQuery = window.matchMedia('(min-width: 590px) and (max-width: 1300px)');
    if (this.collapseQuery.addEventListener) {
      this.collapseQuery.addEventListener('change', this.onCollapseChange);
    } else {
      this.collapseQuery.addListener(this.onCollapseChange); // older Safari
    }
    this.onCollapseChange();
  }

  beforeDestroy(): void {
    if (!this.collapseQuery) return;
    if (this.collapseQuery.removeEventListener) {
      this.collapseQuery.removeEventListener('change', this.onCollapseChange);
    } else {
      this.collapseQuery.removeListener(this.onCollapseChange);
    }
  }
}
